var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    directives: [
      {
        name: "tooltip",
        rawName: "v-tooltip",
        value: _vm.permissionName,
        expression: "permissionName"
      }
    ],
    staticClass: "permission",
    class: "permission--" + _vm.permission
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }